module.exports = __webpack_public_path__ + "static/media/06-archive.8e8f986b.png";